import { useEffect, useMemo, useState } from "react";
import axiosInstance from "../../../services/axiosComman";
import { useFormik } from "formik";
import * as yup from "yup";
import { CloseIcon } from "../../../assets/icons";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { NuInput, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo, { NuMutiSelect } from "../../../utils/Select";
import { CountryMIN } from "../../../assets/data/CountryMini";
import { toast } from "react-toastify";

export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
  standard,
  depList,
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filePathList, setFilePathList] = useState([]);
  const [passwordCheck, setPasswordCheck] = useState("");
  const [isEmail, setIsEmail] = useState(true);
  const [createNew, setCreateNew] = useState({
    standards: [],
    name: "",
    user_name: "",
    email: "",
    mobile: "",
    password: "",
    retypePassword: "",
    country: "",
    location: "",
    department: "",
    isEmailSent: "",
  });

  useEffect(() => {
    setCreateNew({
      name: data?.name,
      user_name: data?.user_name,
      email: data?.email,
      mobile: data?.mobile || "",
      // password: data?.password,
      standards: data?.standards || [],
      country: data?.country,
      location: data?.location,
      department: data?.department,
    });
    setIsEmail(data?.isEmailSent);
  }, [data]);

  function handleImageChange(e) {
    // const { files, value } = e.target;
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      mobile: yup
        .string()
        .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
      password:
        !data &&
        yup
          .string()
          .required("Password is required")
          .min(8, "Password must be at least 8 characters")
          .matches(
            /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\-_=+;:'",.<>?/\\|[\]{} ]).*$/,
            "Password must contain letters, numbers, and at least one special character"
          ),
      retypePassword:
        !data &&
        yup
          .string()
          .matches(passwordCheck, "Passwords not match")
          .min(8, "Retype Password must be Min 8 char")
          .required("Retype Password is required"),
    }),
    onSubmit: (value, { resetForm }) => {
      setIsLoading(true);
      value.isEmailSent = isEmail;
      if (data?.userId) {
        let reqObjs = new FormData();
        // delete value.retypePassword
        reqObjs.append("userData", JSON.stringify(value));
        if (selectedFile !== null) {
          reqObjs.append("userImage", selectedFile[0]);
        }
        axiosInstance
          .put(`/User/${data.userId}`, reqObjs)
          .then((res) => {
            if (res.data) {
              setIsLoading(false);
              resetForm();
              onClose();
              refreshData();
              toast.success(
                <p className="test-sm">
                  {`${res.data.msg || res.data.message}` ||
                    "User Added Successfully"}
                </p>
              );
            } else {
              setIsLoading(false);
              toast.error(
                <p className="test-sm">
                  {`${res.data.msg || res.data.message}` ||
                    "User Added Unsuccessfully"}
                </p>
              );
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(
              <p className="test-sm">{`${
                err.response.data.msg ||
                err.response.data.message ||
                err.response.data.error ||
                "User Added Unsuccessfully"
              }`}</p>
            );
          });
      } else {
        let reqObjs = new FormData();
        // delete value.retypePassword
        reqObjs.append("userData", JSON.stringify(value));
        if (selectedFile !== null) {
          reqObjs.append("userImage", selectedFile[0]);
        }

        axiosInstance
          .post("/User/", reqObjs)
          .then((res) => {
            if (res.data?.status == true) {
              setIsLoading(false);
              resetForm();
              refreshData();
              onClose();
              toast.success(
                <p className="test-sm">
                  {`${res.data.msg || res.data.message}` ||
                    "User Added Successfully"}
                </p>
              );
            } else {
              setIsLoading(false);
              toast.error(
                <p className="test-sm">
                  {`${res.data.msg || res.data.message}` ||
                    "User Added Unsuccessfully"}
                </p>
              );
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(
              <p className="test-sm">{`${
                err.response.data.msg ||
                err.response.data.message ||
                err.response.data.error ||
                "User Added Unsuccessfully"
              }`}</p>
            );
          });
      }
    },
  });

  useMemo(() => {
    setPasswordCheck(formik.values.password);
  }, [formik.values.password]);

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        // onClick={handleOnClose}
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-4 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className=" max-h-[calc(100vh-90px)] overflow-y-auto">
              <div className="relative px-6 flex flex-wrap text-left justify-between">
                <NuInput
                  formik={formik}
                  name="name"
                  label="Name"
                  width="w-1/2"
                  placeholder="Name"
                />
                <NuInput
                  formik={formik}
                  name="user_name"
                  label="User Name"
                  width="w-1/2"
                  placeholder="User Name"
                />
                {!data && (
                  <NuInput
                    formik={formik}
                    name="password"
                    label="Password"
                    width="w-1/2"
                    placeholder="Password"
                    type="password"
                  />
                )}
                <NuMutiSelect
                  formik={formik}
                  name="standards"
                  label="Standards"
                  width="w-1/2"
                  placeholder="Standards"
                  Options={standard}
                />
                {!data && (
                  <NuInput
                    formik={formik}
                    name="retypePassword"
                    label="Retype Password"
                    width="w-1/2"
                    placeholder="Retype Password"
                    type="password"
                  />
                )}
                <NuInput
                  formik={formik}
                  name="email"
                  label="Email"
                  width="w-1/2"
                  placeholder="Email"
                  type="email"
                />
                <NuInput
                  formik={formik}
                  name="mobile"
                  label="Mobile"
                  width="w-1/2"
                  placeholder="mobile"
                  type="number"
                />
                <FormikSelectTwo
                  formik={formik}
                  name="department"
                  label="Department"
                  width="w-1/2"
                  placeholder="Department"
                  Options={depList}
                />
                <FormikSelectTwo
                  formik={formik}
                  name="country"
                  label="Country"
                  width="w-1/2"
                  placeholder="Country"
                  Options={CountryMIN}
                />
                <NuInput
                  formik={formik}
                  name="location"
                  label="City"
                  width="w-1/2"
                  placeholder="City"
                />
                <NuUpload
                  label="User Image"
                  width="w-1/2"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <div className=" px-6 w-full lg:w-1/2 flex justify-start items-end">
                  <div className=" flex gap-2 justify-center pb-1">
                    <input
                      type="checkbox"
                      className=""
                      checked={isEmail == false ? true : false}
                      onChange={(e) => setIsEmail(!e.target.checked)}
                    />
                    <label className=" text-sm">
                      Click here to stop sending E-Mails to this user.
                    </label>
                  </div>
                </div>
                <div className=" w-full flex items-center justify-end px-6 py-6 rounded-b">
                  <CancelButton onClose={resetClose} isLoading={isLoading} />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
